import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Card, CardBody, CardTitle, Col, Collapse, Form, Media, Progress, Row, Table, UncontrolledTooltip } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getUserCreditInfo, getUserPctUnlockHistory } from "../../store/myCredits/actions";
import LoadingModal from "../../components/Common/LoadingModal";
import PeriodBtn from "../../components/Filter/PeriodBtn";
import * as Yup from "yup";
import WeCrestPagination from "../../components/WeCrestPagination";
import SweetAlert from "react-bootstrap-sweetalert";

const MyCredits = () =>{

    const dispatch = useDispatch();
    const { 
        pctUnlockCredit,
        pctUnlockCnt,
        loading,
        pctSubscription,
        pctUnlockHistory,
        noticeStr,
        pctUnlockHistoryTotalPages,
        pctActiveSubCreditList
    } = useSelector((state) => ({
        pctUnlockCredit: state.Unlock.pctUnlockCredit,
        pctUnlockCnt: state.Unlock.pctUnlockCnt,
        loading: state.myCredits.loading,
        pctSubscription: state.Unlock.pctSubscription,
        pctUnlockHistory: state.myCredits.pctUnlockHistory,
        noticeStr: state.myCredits.noticeStr,
        pctUnlockHistoryTotalPages: state.myCredits.pctUnlockHistoryTotalPages,
        pctActiveSubCreditList: state.myCredits.pctActiveSubCreditList
    }));
    const [errMsg, setErrMsg] = useState("");

    const remainPctUnlockCnt = pctSubscription === 'Unlimited' ? 'Unlimited' : pctUnlockCredit - pctUnlockCnt;
    const remainingPctCredit = pctSubscription === 'Unlimited' ? 100 : pctUnlockCredit !== 0 ? Number(((remainPctUnlockCnt / pctUnlockCredit) * 100).toFixed(1)) : 0;

    useEffect(() => {
        dispatch(getUserCreditInfo());
    }, []);

    const userCreditValidation = useFormik({
        enableReinitialize: true,
        initialValues:{
            submitType: "view",
            fromDate: "",
            toDate: "",
            datePeriod: "1 months",
            pageSize: 50,
            curPage: 1,
        },
        validationSchema: Yup.object().shape({
            /* fromDate: Yup.date()
            .max(Yup.ref('toDate'), "From date must be earlier than to date")
            .required("Please Select From date"),
            toDate: Yup.date()
            // .max(new Date(), "Date cannot be in the future")
            .required("Please Select to date"), */
        }),
        validateOnChange: false, 
        validateOnBlur: false,
        onSubmit: (values) => {
            let submitType = values["submitType"];
            
            const startDate = values["fromDate"] // yyyy-mm-dd
            const endDate = values["toDate"] // yyyy-mm-dd
            if (!startDate) {
                setErrMsg("From date is required"); return false;
            } else if (!endDate) {
                setErrMsg("To date is required"); return false;
            } else if (new Date(startDate) > new Date(endDate)) {
                setErrMsg("From date must be earlier than to date"); return false;
            }

            const data = {
                fromDate: values.fromDate,
                toDate: values.toDate,
                datePeriod: values.datePeriod,
                pageSize: values.pageSize,
                curPage: values.curPage,
            };
            if(submitType === "view"){
                dispatch(getUserPctUnlockHistory(data));
                // console.log(pctUnlockHistoryTotalPages)
            }
        },
    })

    const [isCreditsModalOpen, setIsCreditsModalOpen] = useState(true);
    const setMyCreditsLoading = () => {
        dispatch(setMyCreditsLoading(!loading));
    };

    //pagination logic
    const [curPageInput, setCurPageInput] = useState(1);
    const viewList = (sortType, curPage, pageSize) => {
    if(curPage){
        if(curPage > pctUnlockHistoryTotalPages) {
            curPage = pctUnlockHistoryTotalPages;
        } else if (curPage <= 0) {
            curPage = 1;
        }
    }

    userCreditValidation.setFieldValue("submitType", "view");
    
    if(curPage){
        userCreditValidation.setFieldValue("curPage", curPage);
        setCurPageInput(curPage);
    }else{
        userCreditValidation.setFieldValue("curPage", 1);
        setCurPageInput(1);
    }
    if(pageSize){
        userCreditValidation.setFieldValue("pageSize", pageSize);
    }
    userCreditValidation.handleSubmit(userCreditValidation.values);
    }

    return(
        <React.Fragment>
            <Form onSubmit={userCreditValidation.handleSubmit}>
                <div className="page-content">
                    <div className="container-fluid">
                        <Card>
                            <Link onClick={() => {setIsCreditsModalOpen(!isCreditsModalOpen)}} className="text-dark" to="#">
                             <div className="p-4">
                                <Media className="d-flex align-items-center">
                                    <div className="flex-shrink-0 me-3">
                                    <i className="uil uil-book text-primary h2"></i>
                                    </div>
                                    <div className="flex-grow-1 overflow-hidden">
                                    <h5 className="font-size-16 mb-1">My Credits</h5>
                                    <p className="text-muted mb-0">
                                        Use this tool to monitor your credit usage.
                                    </p>
                                    </div>
                                    <i className="uil uil-filter fonts-size-24 text-muted"></i>
                                </Media>
                            </div>
                            </Link>
                            <Collapse isOpen={isCreditsModalOpen}>
                            <div className="p-4 border-top">
                            <h5 className="font-size-16 mb-1">PCT Credit Usage</h5>
                            <div className="row">
                            <div className="text-end" style={{ fontWeight: 'bold', color: '#75ba75',width: '89%' }}>
                                {remainingPctCredit}% credits remaining
                            </div>
                            <div className="pt-1" style={{ width: '100%' }}>
                            <Progress 
                                value={remainingPctCredit} 
                                style={{ backgroundColor: '#e9ecef' }} 
                                barStyle={{ backgroundColor: '#71a3c1' }} 
                            />
                            </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-2">
                                    <h6 font-size-17>Subscription</h6>
                                </div>
                                <div className="col-3">
                                    <h6 font-size-17>Credits per month</h6>
                                </div>
                                <div className="col-2">
                                    <h6 font-size-17>Credits used</h6>
                                </div>
                                <div className="col-2">
                                    <h6 font-size-17>Remaining credits</h6>
                                </div>
								<div className="col-3">
									{
										pctActiveSubCreditList && pctActiveSubCreditList.length == 1 ?  (
											pctActiveSubCreditList[0].creditRefillDate ? 
												<h6 font-size-17>Credit refill date</h6> :
													<h6 font-size-17>Credit expiry date</h6>
										) : pctActiveSubCreditList && pctActiveSubCreditList.length == 0 ?
                                                <h6 font-size-17>Credit expiry date</h6> :
													pctActiveSubCreditList && pctActiveSubCreditList.length > 0 ?
                                                    	<h6 font-size-17>Credit refill date / <br /> Credit expiry date</h6> :
															<h6 font-size-17>Credit expiry date</h6>
									}
								</div>
                            </div>
                            <>
                                {pctActiveSubCreditList && pctActiveSubCreditList.length > 0 ? pctActiveSubCreditList.map((item, index) => {
                                    return (
                                        <div key={index} class="row">
                                            <div className="col-2">{item.subscriptionName}</div>
                                            <div className="col-3">{item.subscriptionName === 'Unlimited' ? 'Unlimited' : item.totalCredit}</div>
                                            <div className="col-2">{item.usedCredit}</div>
                                            <div className="col-2">{item.subscriptionName === 'Unlimited' ? 'Unlimited' : item.totalCredit - item.usedCredit}</div>
											<div className="col-3">{item.creditRefillDate ? item.creditRefillDate : item.creditExpiryDate}</div>
                                        </div>
                                    );
                                }) : 
                                pctSubscription === 'Unlimited' ?
                                (
                                    <div class="row">
                                        <div className="col-2">Unlimited</div>
                                        <div className="col-3">Unlimited</div>
                                        <div className="col-2">_</div>
                                        <div className="col-2">Unlimited</div>
										<div className="col-3">Unlimited</div>
                                    </div>
                                )
                                :
                                (
                                    <div class="row">
                                        <div className="col-2">No subscription</div>
                                        <div className="col-3">0</div>
                                        <div className="col-2">0</div>
                                        <div className="col-2">0</div>
										<div className="col-3">-</div>
                                    </div>
                                )}
                            </>
                            </div>
                            <div className="p-4 border-top">
                                <h5 className="font-size-16 mb-1">Unlocked cases</h5>
                                <Row>
                                    <label className="col-md-3 pt-2">Unlocked date</label>
                                    <div className="col-md-9">
                                        <PeriodBtn formik={userCreditValidation}/>
                                    </div>
                                </Row>
                                <Row>
                                <Col md={{ span: 5, offset: 3 }}>
                                <div id="viewPctUnlockHistoryWrapper" style={{ display: 'inline-block' }}>
                                    <button
                                    type="button"
                                    className="waves-effect waves-light btn btn-primary"
                                    disabled={pctSubscription==='N'}
                                    style={{ width: '148.58px' }}
                                    onClick={() => {
                                        userCreditValidation.handleSubmit(userCreditValidation.values);
                                    }}
                                    >
                                    View
                                    </button>
                                </div>
                                {pctSubscription === 'N' && (
                                    <UncontrolledTooltip
                                    placement="top"
                                    target="viewPctUnlockHistoryWrapper"
                                    autohide={true}
                                    >
                                    Please subscribe to a PCT plan to unlock this feature.
                                    </UncontrolledTooltip>
                                )}
                                </Col>
                                </Row>
                            </div>
                            </Collapse>
                        </Card>
                        {loading ? (
                            <LoadingModal
                            loading={loading}
                            setLoading={setMyCreditsLoading}
                            ></LoadingModal>
                        ) : null}

                        {
                            errMsg !== "" ? (
                              <SweetAlert
                                title={errMsg}
                                onConfirm={() => {
                                  setErrMsg("");
                                }}
                              >
                              </SweetAlert>
                            ) 
                              : 
                            null
                        }

                        {noticeStr && noticeStr !== ''?
                        <Row>
                            <Col lg={12}>
                            <Card>
                                <CardBody>
									<CardTitle className="title-muted mb-0">
										<p style={{ isWhiteSpace: "pre" }}>{noticeStr}</p>
									</CardTitle>
                                    <div className="col-md-6">
                                    <div className="table-responsive">
                                        <Table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Unlocked date</th>
                                                    <th className="text-center">Application number</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pctUnlockHistory && pctUnlockHistory.length > 0 ? pctUnlockHistory.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">
                                                        {(() => {
                                                            const [datePart] = item.unlockDate.split(' '); 
                                                            const [year, month, day] = datePart.split('-');
                                                            return `${year.slice(2)}/${month}/${day}`; 
                                                        })()}
                                                        </td>
                                                        <td className="text-center">{item.irNumber}</td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="2" className="text-center">No unlock history found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                    </div>
                                    <WeCrestPagination
                                        viewList={viewList}
                                        pageSize={userCreditValidation.values.pageSize}
                                        curPage={userCreditValidation.values.curPage}
                                        totalPage={pctUnlockHistoryTotalPages}
                                        curPageInput={curPageInput}
                                        setCurPageInput={setCurPageInput}
                                        pageSizeList={[50,100,250,500,1000]}
                                    />
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                        : null}
                    </div>   
                </div>
            </Form>
        </React.Fragment>
    )

}

export default MyCredits;